import { sum } from "lodash";

import type { IDataFetcher, IDataFetcherFactory } from "app/components/widget/widget-fetchers/IDataFetcher";
import type { IWidget } from "app/components/widget/widget-types/Widget";
import type { ApiParams } from "app/pages/website-analysis/traffic-sources/search/tabs/SearchOverviewTraffic/Types";
import { fetchWebsitesFaviconsQuery } from "app/services/sitesService/queries/sitesQueries";
import { getCompareTotalVisitsData, getMMXTrafficData } from "app/services/WebsiteAnalysis/SearchOverviewApiService";
import { devicesTypes } from "app/UtilitiesAndConstants/Constants/DevicesTypes";

interface ITotalVisitsData {
    Data: Record<string, { [key: string]: ChannelBreakdown }>;
}
type Favicons = Record<string, string>;
type ChannelBreakdown = Record<string, number>;

class SearchOverviewTotalVisitsCompareDataFetcherFactory<T> implements IDataFetcherFactory<T> {
    create(widget: IWidget<T>): IDataFetcher<T> {
        const { keys, webSource } = widget.apiParams;
        const isTotal = webSource === devicesTypes.TOTAL;

        return {
            async fetch() {
                if (isTotal) {
                    const [totalVisitsData, favicons]: [ITotalVisitsData, Favicons] = await Promise.all([
                        getMMXTrafficData(widget.apiParams as unknown as ApiParams),
                        fetchWebsitesFaviconsQuery(keys.split(",")),
                    ]);

                    const totalData = totalVisitsData.Data[devicesTypes.TOTAL];
                    const parsedData = Object.entries(totalData).map(([key, value]: [string, ChannelBreakdown]) => {
                        const searchTotal = value["Organic Search"] + value["Paid Search"];
                        const sumOfAllChannels = sum(Object.values(value));
                        const shareOfVisits = searchTotal / sumOfAllChannels;

                        return {
                            Domain: key,
                            Favicon: favicons[key],
                            SearchTotal: searchTotal,
                            ShareOfVisits: shareOfVisits,
                        };
                    });
                    return { Data: parsedData };
                } else {
                    return await getCompareTotalVisitsData(widget.apiParams as unknown as ApiParams);
                }
            },
            destroy: () => undefined,
        };
    }
}

export default new SearchOverviewTotalVisitsCompareDataFetcherFactory();
